import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default function usePaginationHelper (sortBy?: string) {
    const route = useRoute()
    const router = useRouter()
    const currentPage = computed(() => route.query.page === null || route.query.page === undefined ? '1' : route.query.page)
    if (typeof sortBy === 'undefined') {
        sortBy = 'name' // best guess
    }
    const pagination = ref({
        rowsPerPage: 10,
        page: +currentPage.value,
        sortBy: sortBy,
        descending: false
    })

    watch(pagination, () => {
        const routeQuery = Object.assign({}, { query: { page: pagination.value.page.toString() } })
        router.push(routeQuery)
    })

    return {
        currentPage,
        pagination
    }
}
